module.exports = __webpack_public_path__ + "static/media/foodmaps_selected.c7a9ec5b.svg";